import { BigNumberSupport } from "./ListBigNumber";

interface Props {
    title: string;
}

const SupportPanel = ({ title }: Props) => {
    return (
        <div style={{ height: 38, padding: '10px 0px' }} className={`panel panel-default bg-white panel-body panel-blank shadow-default padding-0 margin-0 position-relative cursor-pointer flex-1-1 rounded rounded-small overflow-hidden`}>
            <div className="position-relative width-100pct height-100pct padding-x-20 display-flex align-items-center">
                <span className="text-size-14 text-medium text-color-dark line-height-14 align-self-center">{title}</span>
                <span className={`position-absolute left-0 top-0 bottom-0 height-100pct width-4`} style={{ background: '#344054' }} />
            </div>
        </div>
    )
}

export default SupportPanel;